angular.
module("dx.webapp.sorting").
constant("DX_JOB_SORT_PREDICATE", Object.freeze({
	TYPE: "type",
	STATUS: "status",
	DESCRIPTION: "taskCountDone",
	DATE: "created",
	ID: "id",
	ORGANIZATION: "organizationId",
}));
